module.exports = function() {
  return new Worker(__webpack_public_path__ + "8e7dc1817a36ec85ad1c.worker.js");
};